export const environment = {
    api: import.meta.env.VITE_API_URL || "/api",
    external: import.meta.env.VITE_EXTERNAL_URL || import.meta.env.VITE_PGEX_URL || "/external",
    pgexEnabled: import.meta.env.VITE_PGEX_ENABLED === "true",
};
